import { adCustomizersStyle } from '@bingads-webui-campaign-react/common-styles';
import {
  getCommonPreviewContainerStyles,
  getCrudAdImagePreviewStyles,
  getMMAPreviewStyles,
} from '@bingads-webui-campaign-react/shared-image-preview-styles';

export const getMMAStyles = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  mma: {
    ...getCommonPreviewContainerStyles(),
    ...getCrudAdImagePreviewStyles(_, { palette, iconFontFamily }),
    ...getMMAPreviewStyles(),
    ...adCustomizersStyle({ palette, iconFontFamily }),

    '& .ad-edit-and-preview-container': {
      position: 'relative',

      '& .new-preview-carousel-container': {
        background: 'white',
      },
    },

    '& .left-column': {
      width: '600px',
      minWidth: '600px',
    },
  },
});
